import React from "react";
import {GlobalAlertContextConsumer} from "./GlobalAlertContextProvider";
import AlertBadge from "./AlertBadge";

class ItemMaintenanceAlertBadge extends React.Component<any, any> {
  public render() {
    return (
      <GlobalAlertContextConsumer>
        {(globalAlertContextState) => {
          return (
            <AlertBadge count={globalAlertContextState.maintenance.alertCount} />
          );
        }}
      </GlobalAlertContextConsumer>
    );
  }
}

export default ItemMaintenanceAlertBadge;


// WEBPACK FOOTER //
// ./src/app/alert/ItemMaintenanceAlertBadge.tsx